// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".heading-block img[data-v-4e6c87f8]{margin-right:20px}.heading-block.flex-center[data-v-4e6c87f8]{display:flex;align-items:center}@media(max-width:859px){.heading-block img[data-v-4e6c87f8]{width:24px;height:24px;margin-right:15px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
